<!-- <label>{{ label }}</label> -->
<div class="input-group">
  <input
    [ngStyle]="{ visibility: hide ? 'hidden' : null }"
    #dp="ngbDatepicker"
    #input
    type="text"
    [class]="inputClasses"
    [class.is-invalid]="hasError"
    name="dp"
    ngbDatepicker
    [(ngModel)]="innerValue"
    (ngModelChange)="onModelChange()"
    [disabled]="isDisabled"
    [container]="$any(container)"
    [autoClose]="autoClose"
    [minDate]="$any(internalMinDate)"
    [maxDate]="$any(internalMaxDate)"
    [readOnly]="readOnly"
    />
  @if (showIcon && !readOnly) {
    <div class="input-group-append">
      <div class="input-group-text pointer" (click)="onToggle()">
        <i class="feather icon-calendar"></i>
      </div>
    </div>
  }
</div>
